import type {
  RecommendationFilter,
  RecommendationTab,
} from "@app/analytics/Recommendations/types";
import ROUTES from "@app/common/routes";

export const TABS: RecommendationTab[] = [
  {
    id: "new",
    label: "New",
    route: ROUTES.RECOMMENDATIONS,
  },
  {
    id: "reviewed",
    label: "Reviewed",
    route: ROUTES.REVIEWED_RECOMMENDATIONS,
  },
];

export const ALL_RESULTS_FILTER: RecommendationFilter = {
  id: "all",
  label: "All Results",
  actionKinds: [],
};

export const RECOMMENDATION_ACTION_FILTERS: RecommendationFilter[] = [
  {
    id: "action_items",
    label: "Action Items",
    actionKinds: [], // TODO (ENG-8413) - fill in with new type
  },
  {
    id: "cancel",
    label: "Cancel",
    actionKinds: ["delete_event"],
  },
  {
    id: "decline",
    label: "Decline",
    actionKinds: ["decline_invite", "respond_tentative"],
  },
  {
    id: "remove",
    label: "Remove",
    actionKinds: ["remove_invitee", "mark_optional"],
  },
  {
    id: "review",
    label: "Review",
    actionKinds: ["acknowledge", "adjust_start_time", "adjust_end_time"],
  },
];
